<template>
  <div
    v-if="!disableSelect"
    class="flex min-h-[3rem] cursor-pointer items-center px-6 py-[0.594rem]"
    :class="[isActive ? 'bg-slate text-white' : 'hover:bg-gray-lighten3']"
    @click.stop.prevent="handleSelectOption(option)"
  >
    <slot>{{ option[itemText] }}</slot>
  </div>
  <div
    v-else
    class="flex min-h-[3rem] cursor-pointer items-center px-6 py-[0.594rem]"
    :class="[isActive ? 'bg-slate text-white' : 'hover:bg-gray-lighten3']"
  >
    <slot>{{ option[itemText] }}</slot>
  </div>
</template>

<script setup lang="ts">
import { computed, inject } from 'vue';
import type { WritableComputedRef } from 'vue';

interface Props {
  option?: any;
  disableSelect?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  option: () => ({}),
  disableSelect: false,
});

const {
  valueLocal: selectValue,
  selectOption,
  itemId,
  itemText,
} = inject('selectData') as {
  valueLocal: WritableComputedRef<any>;
  selectOption: (option: any) => void;
  itemId: string;
  itemText: string;
};

const isActive = computed(() => props.option[itemId] === selectValue.value);

const handleSelectOption = (option: any) => {
  selectOption(option);
};
</script>
